import { Button, DatePicker, Form, Input, Modal, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import { ApiManager, Locale } from "../../utils";

const api = ApiManager.getInstance();
const i18n = Locale.getInstance();

function CommissionPaidOtherWayModal({
  visible,
  commission,
  token,
  onCancel,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [evidenceFileList, setEvidenceFileList] = useState([]);

  const handleCancel = () => {
    form.resetFields();
    setEvidenceFileList([]);
    onCancel();
  };

  const uploadEvidence = async ({ file, onError, onSuccess }) => {
    if (!file || !token) {
      onError("invalid file");
      return;
    }

    try {
      const res = await api.common.uploadImages.run({
        token,
        uploadFiles: [{ file }],
        uploadType: "commission-evidence",
      });
      if (res.result && res.data && res.data[0]) {
        onSuccess(res.data[0], file);
      } else {
        onError(res.message || "upload failed");
      }
    } catch (error) {
      onError(error);
    }
  };

  const handleSubmit = async (values) => {
    if (!commission || !token) {
      return;
    }

    const evidence = evidenceFileList[0];
    const payload = {
      pay_type: values.pay_type,
      paid_at: values.paid_at.format("YYYY-MM-DD"),
    };
    if (evidence && evidence.response) {
      payload.evidence_image_url = evidence.response.url;
      payload.evidence_image_path = evidence.response.path;
    }

    setSubmitting(true);
    try {
      const res = await api.commission.paidOtherWay.run({
        token,
        path: { id: commission.id },
        data: payload,
      });
      if (res.result) {
        form.resetFields();
        setEvidenceFileList([]);
        onSuccess();
        onCancel();
      } else {
        Modal.error({
          title: i18n.t("base.modal.errorTitle"),
          content: res.message,
        });
      }
    } catch (error) {
      Modal.error({
        title: i18n.t("base.modal.errorTitle"),
        content: error.message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={i18n.t("commissionList.paidOtherWayTitle")}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      {commission && (
        <p style={{ marginBottom: 16, color: "rgba(0,0,0,0.65)" }}>
          {i18n.t("commissionList.order_id")}: {commission.order_id} / ID:{" "}
          {commission.id}
        </p>
      )}
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="pay_type"
          label={i18n.t("commissionList.paidOtherWayPayType")}
          rules={[
            {
              required: true,
              message: i18n.t("commissionList.paidOtherWayPayTypeRequired"),
            },
          ]}
        >
          <Input placeholder={i18n.t("commissionList.paidOtherWayPayTypePlaceholder")} />
        </Form.Item>
        <Form.Item
          name="paid_at"
          label={i18n.t("commissionList.paidOtherWayDate")}
          rules={[
            {
              required: true,
              message: i18n.t("commissionList.paidOtherWayDateRequired"),
            },
          ]}
        >
          <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item label={i18n.t("commissionList.paidOtherWayEvidence")}>
          <Upload
            listType="picture-card"
            fileList={evidenceFileList}
            customRequest={uploadEvidence}
            accept="image/jpeg,image/jpg,image/png"
            maxCount={1}
            onChange={({ fileList }) => setEvidenceFileList(fileList.slice(-1))}
          >
            {evidenceFileList.length === 0 && (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>
                  {i18n.t("commissionList.paidOtherWayEvidenceUpload")}
                </div>
              </div>
            )}
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting}>
            {i18n.t("commissionList.paidOtherWaySubmit")}
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={handleCancel}>
            {i18n.t("common.cancelText")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default CommissionPaidOtherWayModal;
